"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computePolyTopology = computePolyTopology;
var _entityHitTest = require("./entityHitTest");
var _vector = require("./vector");
/**
 * Detects limited topological information about an array of closed polys.
 * @param polys An array of closed, non-intersecting polys
 * @returns An array of information, with one item for each poly, containing the topological information for that poly
 */
function computePolyTopology(polys) {
  /* Properties returned for each poly: 
   * type write-once (except for a sanity check)
   * insideOf write-once, read-multiple
   * parentId write-once
   * isOuterMost write-once
   */

  let topos = polys.map(() => ({}));

  // Determine whether each poly is an inner or outer poly
  // Also build a list of outer polys so that we can simplify part matching later
  for (let i = 0; i < polys.length; i++) {
    const poly = polys[i];
    const topo = topos[i];

    // Choose the midpoint in the poly's first segment (this is very helpful for processing bends, since this point will never lie on a bend line)
    let p = (0, _vector.mul)((0, _vector.add)(poly[0], poly[1 % poly.length]), 0.5);
    // let p = poly[Math.floor(Math.random() * poly.length)]

    // Make a fake "part" out of every other contour, and check whether a point on this contour is inside it
    topo.insideOf = []; // id's of contours that surround this contour

    for (let j = 0; j < polys.length; j++) {
      if (i === j) continue;
      let poly2 = polys[j];
      if ((0, _entityHitTest.isPointInsidePoly)(p, poly2, false)) topo.insideOf.push(j);
    }
    if (topo.insideOf.length % 2 === 0) {
      topo.type = 'outer';
    } else {
      topo.type = 'inner';
    }
  }

  // Now, determine each poly's direct parent by examining the insideOf arrays.
  // Root nodes will have no items in the insideOf array.
  // Polys with exactly one item can be assigned that id as the parent.
  // Polys with two items--the item that has more items itself is the direct parent.
  // And so on.
  for (let h = 0; h < topos.length; h++) {
    const t = topos[h];

    // For each contour, find the insideOf contour that has the most items it's inside of itself. That should be this contour's direct parent.
    if (t.insideOf) {
      if (t.insideOf.length > 0) {
        let parentId = -1;
        let mostItems = -1;
        for (let i = 0; i < t.insideOf.length; i++) {
          let parent = topos[t.insideOf[i]]; // parent = topo[t.insideOf[i]] works because we are using array indices throughout
          if (!parent.insideOf) {
            console.log(`Poly ${h}'s parent ${t.insideOf[i]} has no insideOf`);
          }
          if (parent.insideOf.length > mostItems) {
            parentId = t.insideOf[i];
            mostItems = parent.insideOf.length;
          }
        }
        if (parentId === -1) {
          throw new Error('Could not determine parent contour');
        }
        t.parentId = parentId;
        t.isOuterMost = false;
      } else {
        t.parentId = -1;
        t.isOuterMost = true;
      }
    }
  }

  // Make sure all properties were set. Typescript won't check this because we coerced the type of topos when it was
  // initialized.
  for (let t of topos) {
    if (t.parentId == null || t.isOuterMost == null || t.insideOf == null || t.type == null) {
      throw new Error('Topo has a missing property: ' + JSON.stringify(t));
    }
  }
  return topos;
}